<script setup>
  import {onMounted,reactive} from 'vue';
  import {ApiWrapper} from "@/Utils/ApiWrapper";
  import {ToastUtil} from "@/Utils/ToastUtil";

  const data = reactive({
    search: null,
    dataLoading: true,
    disb: null,
    holdbacks: null,
    adj: null,
    headers: [
      { title: 'Date', key: 'date' },
      { title: 'Disbursements', key: 'disbursements' },
      { title: 'Holdbacks', key: 'holdbacks' },
      { title: 'Released Holdbacks', key: 'holdbacksreleased' },
      { title: 'Adjustments', key: 'adjustments' },
    ],
    items: [],
  });

  const getString = (item) => {
    if(item.datestarted){
      return item.datestarted + ' To ' + item.datefinished
    }else{
      return 'Pending'
    }
  }

  const getData = () => {
    data.dataLoading = true;
    ApiWrapper.post('adjuster-pay', 'current-adjuster-pay', {})
        .then((response) => {
          if(response.data){
            data.items = response.data;
          }
        })
        .catch((e)=>{
          ToastUtil.error(e);
        })
        .finally(()=>{
          data.dataLoading = false;
        });

  }

  onMounted(() => {
    getData();
  });

</script>

<template>
  <v-container id="entreos-resize-target" fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar density="compact" flat color="white">
        <v-toolbar-title>Your Pay Periods</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>

      </v-toolbar>

      <v-data-table density="compact" :items="data.items" :headers="data.headers" :search="data.search" :loading="data.dataLoading"
                    loading-text="Loading... Please wait">

        <template v-slot:[`item.date`]="{ item }">
          <RouterLink :to="`/mypayperiod/${item.id}`">
            {{getString(item)}}
          </RouterLink>
        </template>

      </v-data-table>
    </v-card>
  </v-container>
</template>

<style scoped>
  .container {
    padding: 5px;
  }

  [v-cloak] {
    display: none;
  }

  .v-list-item-subtitle {
    font-size: 10px !important;
    color:black;
  }

  .v-toolbar-subtitle {
    color:black !important;
  }
</style>